import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RoundCount from 'Components/RoundCount';

import { useShouldDisableJSRouting } from '@/components/providers/DisableJSRoutingProvider';

import style from './style.scss';

/**
 * Renders a navigation item component.
 *
 * @param {object} props - The properties for the navigation item.
 * @param {string} [props.url] - The URL for the navigation item.
 * @param {string} props.text - The text for the navigation item.
 * @param {import('@fortawesome/fontawesome-svg-core').IconDefinition} [props.icon] - The icon for the navigation item.
 * @param {import('preact/compat').ReactElement} [props.customIcon] - The custom icon for the navigation item.
 * @param {function} [props.onClick] - The click event handler for the navigation item.
 * @param {number} [props.count=0] - The count for the navigation item.
 * @param {string} [props.target] - The target for the navigation item.
 * @return {import('preact/compat').ReactElement} The rendered navigation item component.
 */
const NavItem = ({ url, text, icon, customIcon, onClick, count = 0, target }) => (
  <nav className={style.navItem}>
    <a data-native={useShouldDisableJSRouting()} href={url} onClick={onClick} target={target}>
      {customIcon || <FontAwesomeIcon icon={icon} />}
      <div className={style.text}>
        {count > 0 && <RoundCount count={count} />}
        <span>{text}</span>
      </div>
    </a>
  </nav>
);

export default NavItem;
